module.exports = __webpack_public_path__ + "img/lianxiwomen.136e1892.png";